import { NgModule } from '@angular/core';
import { FiHighlightPipe } from './fi-highlight.pipe';

@NgModule({
    declarations: [FiHighlightPipe],
    exports: [FiHighlightPipe],
})
export class FiHighlightModule {}
